<template>
  <div id="profile-upload">
    <div class="user flex justify-center">
      <input
        type="file"
        id="upload-photo"
        ref="file"
        @change="handleFileUpload()"
      />
      <label class="upload-picture" for="upload-photo">
        {{ label }}
      </label>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String
    }
  },
  data() {
    return {
      file: ""
    };
  },
  methods: {
    // Submits the file to the server
    async handleFileUpload() {
      this.file = this.$refs.file.files[0];
      this.$emit("update-picture", this.file);
    }
  }
};
</script>
<style>
#profile-upload .user {
  text-align: center;
}
#profile-upload .user .upload-photo {
  display: block;
}
.upload-picture {
  cursor: pointer;
  font-style: normal;
  font-weight: 600;
  font-size: var(--fs-xs);
  line-height: 16px;
  letter-spacing: 0.08em;
  text-transform: capitalize;
  color: var(--accent-600);
  transition: color var(--dur) var(--ease);
}
.upload-picture:hover {
  color: var(--accent-700);
}
#upload-photo {
  opacity: 0;
  z-index: -1;
  width: 0;
}
</style>
